import React from 'react'
import PropTypes from 'prop-types'
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from "react-json-pretty/dist/monikai";

import {
  StyledWrapper,
} from './JsonCodeStyled.styled';

const CodeStyle = props => {

  const { data } = props;

  if (!data) {
    return null;
  }

  return (
    <StyledWrapper>
      <JSONPretty id="json-pretty" data={data} theme={JSONPrettyMon}></JSONPretty>
    </StyledWrapper>
  )
}

CodeStyle.propTypes = {
  data: PropTypes.object,
}

export default CodeStyle
